/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Controller } from 'react-hook-form';
import { Box, FormControl } from '@material-ui/core';
import {
  FormInputsContainer,
  CustomTextField,
  CustomSelect,
  CustomInputLabel,
  CustomForm,
  CustomFormError,
  FormRowTextFildsContainer,
  CustomMenuItem,
} from '../../../../styles';
import useConfigsStore from '../../../../../../store/configsStore';

export default function ItemCreationForm({ useFormProps }) {

  //!
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );
  const itemCategories = useConfigsStore((state) => state.itemCategories);
  const itemReasons = useConfigsStore((state) => state.itemReasons);
    
  const fontColor = devolutionPageConfigs?.fontColor;
  const fontFamily =
    devolutionPageConfigs?.fontFamily === ''
      ? 'inherit'
      : devolutionPageConfigs?.fontFamily;
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useFormProps;

  return (
    <CustomForm id="order-creation-items" onSubmit={handleSubmit()}>
      <FormInputsContainer>
        <Controller
          name="itemName"
          control={control}
          rules={{ required: true }}
          defaultValue={''}
          render={({ field }) => (
            <CustomTextField
              {...field}
              bordercolor={fontColor || 'var(--color-blue-primary)'}
              fullWidth
              label="Nome do item"
              variant="outlined"
              inputProps={{
                style: { fontFamily },
              }}
              InputLabelProps={{
                shrink: field.value,
                style: { fontFamily },
              }}
            />
          )}
        />
        {errors && errors.itemName && errors.itemName.type === 'required' && (
          <CustomFormError>Nome do item é obrigatório</CustomFormError>
        )}
        <Box sx={{ padding: '5px 0' }} />
        <FormRowTextFildsContainer>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Controller
              name="quantity"
              control={control}
              rules={{ required: true }}
              defaultValue={''}
              render={({ field, field: { onChange } }) => (
                <CustomTextField
                  {...field}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (value < 0) {
                      return;
                    }
                    onChange(value);
                  }}
                  type="number"
                  bordercolor={fontColor || 'var(--color-blue-primary)'}
                  fullWidth
                  label="Quantidade"
                  variant="outlined"
                  inputProps={{
                    style: { fontFamily },
                  }}
                  InputLabelProps={{
                    shrink: field.value,
                    style: { fontFamily },
                  }}
                />
              )}
            />
            {errors &&
              errors.quantity &&
              errors.quantity.type === 'required' && (
                <CustomFormError>Quantidade é obrigatório</CustomFormError>
              )}
          </Box>
          <Box sx={{ padding: '0 5px' }} />
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Controller
              name="price"
              control={control}
              rules={{ required: true }}
              defaultValue={''}
              render={({ field, field: { onChange } }) => (
                <CustomTextField
                  {...field}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (value < 0) {
                      return;
                    }
                    onChange(value);
                  }}
                  type="number"
                  bordercolor={fontColor || 'var(--color-blue-primary)'}
                  fullWidth
                  label="Valor"
                  variant="outlined"
                  inputProps={{
                    style: { fontFamily },
                  }}
                  InputLabelProps={{
                    shrink: field.value,
                    style: { fontFamily },
                  }}
                />
              )}
            />
            {errors && errors.price && errors.price.type === 'required' && (
              <CustomFormError>Preço é obrigatório</CustomFormError>
            )}
          </Box>
        </FormRowTextFildsContainer>
        <Box sx={{ padding: '5px 0' }} />
        <Controller
          name="category"
          control={control}
          rules={{ required: true }}
          defaultValue={''}
          render={({ field }) => (
            <FormControl fullWidth size="medium" variant="outlined">
              <CustomInputLabel
                id="category-label"
                style={{ fontFamily }}
                textcolor={fontColor || 'var(--color-blue-primary)'}
              >
                Categoria
              </CustomInputLabel>
              <CustomSelect
                {...field}
                bordercolor={fontColor || 'var(--color-blue-primary)'}
                labelId="category-label"
                label="Categoria"
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}
                style={{ fontFamily }}
              >
                {itemCategories?.map(
                  (category) =>
                    category.eligible && (
                      <CustomMenuItem
                        key={category.id}
                        value={category.id}
                        style={{ fontFamily }}
                      >
                        {category.name}
                      </CustomMenuItem>
                    ),
                )}
              </CustomSelect>
            </FormControl>
          )}
        />
        {errors && errors.category && errors.category.type === 'required' && (
          <CustomFormError>Selecione uma categoria</CustomFormError>
        )}
        <Box sx={{ padding: '5px 0' }} />
        <Controller
          name="reason"
          control={control}
          rules={{ required: true }}
          defaultValue={''}
          render={({ field }) => (
            <FormControl fullWidth size="medium" variant="outlined">
              <CustomInputLabel
                id="reason-label"
                style={{ fontFamily }}
                textcolor={fontColor || 'var(--color-blue-primary)'}
              >
                Motivo da devolução
              </CustomInputLabel>
              <CustomSelect
                {...field}
                bordercolor={fontColor || 'var(--color-blue-primary)'}
                labelId="reason-label"
                label="Motivo da devolução"
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}
                style={{ fontFamily: fontFamily }}
              >
                {itemReasons?.map(
                  (reason) =>
                    reason.isSelected && (
                      <CustomMenuItem
                        key={reason.id}
                        value={reason.id}
                        style={{ fontFamily: fontFamily }}
                      >
                        {reason.description}
                      </CustomMenuItem>
                    ),
                )}
              </CustomSelect>
            </FormControl>
          )}
        />
        {errors && errors.reason && errors.reason.type === 'required' && (
          <CustomFormError>Selecione um motivo</CustomFormError>
        )}
        <Box sx={{ padding: '5px 0' }} />
        <Controller
          name="resolution"
          control={control}
          rules={{ required: true }}
          defaultValue={''}
          render={({ field }) => (
            <CustomTextField
              {...field}
              bordercolor={fontColor || 'var(--color-blue-primary)'}
              fullWidth
              label="Resolução solicitada"
              variant="outlined"
              inputProps={{
                style: { fontFamily },
              }}
              InputLabelProps={{
                shrink: field.value,
                style: { fontFamily },
              }}
            />
          )}
        />
        {errors &&
          errors.resolution &&
          errors.resolution.type === 'required' && (
            <CustomFormError>Selecione uma resolução</CustomFormError>
          )}
        <Box sx={{ padding: '5px 0' }} />
      </FormInputsContainer>
    </CustomForm>
  );
}
